/**
 * Shared Footer
 *
 * Minimal shared footer snippet for app views (distinct from landing footer).
 */
import React from 'react';

export function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-900 mt-8 py-8">
      <div className="text-center text-sm text-gray-600 dark:text-gray-400">
        Powered by &copy; {new Date().getFullYear()} FullPAC, Inc.
      </div>
    </footer>
  );
}

export default Footer; 